import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MdrService } from 'src/app/services/mdr.service';
import { MdrPaginatedResponse, RestaurantListItem } from 'src/app/model/mdr.model';
import { MdrPaginatedListStore } from './paginated-list.store';

// --- Public types ----------------------------------------------------------

export interface RestaurantFilters {
  ships?: string[];
}

// --- Store -----------------------------------------------------------------

/**
 * Store for the "Restaurants" list (FUN6 — Cap. 2.2.6).
 *
 * Strategy: **plain server-side pagination**. The list is small and mutated
 * in place (create/edit/delete), so the base store's prefetch/cache machinery
 * is intentionally left dormant — every navigation hits the server, and
 * `refresh()` is called after a mutation to re-read the current page.
 */
@Injectable()
export class MdrRestaurantsListStore extends MdrPaginatedListStore<RestaurantListItem, RestaurantFilters> {

  constructor(private mdrService: MdrService) {
    super();
  }

  protected keyOf(item: RestaurantListItem): string {
    return String(item.id);
  }

  /** Plain navigation — always a foreground load. */
  override goToPage(target: number): void {
    if (target < 1 || target === this.currentPage()) return;
    this.loadPage(target);
  }

  /** Re-reads the current page; call after create/edit/delete. */
  refresh(): void {
    this.loadPage(this.currentPage());
  }

  // --- Base hooks ----------------------------------------------------------

  protected fetchPage(page: number): Observable<MdrPaginatedResponse<RestaurantListItem>> {
    const { ships } = this.filters();
    const { by, order } = this.sort();
    return this.mdrService.getRestaurants(page, this.pageSize(), ships, by, order);
  }
}
